import { BorderStyle } from "../../VideoSegmentMultiFocus";
import React from "react";

interface BorderWrapperProps {
    borderStyle: BorderStyle;
    borderThickness: number;
    borderRadius: number;
    children: React.ReactNode;
}

export const getBorderStyle = (borderStyle: BorderStyle, borderThickness: number): React.CSSProperties => {
    const offset = borderThickness * 3;
    
    switch (borderStyle) {
        case BorderStyle.NoBorder:
            return { border: 'none' };
        case BorderStyle.Shadow:
            return { 
                boxShadow: `rgba(0, 0, 0, 0.25) 12px 12px 25px -16px, rgba(0, 0, 0, 0.25) 16px 16px 50px -25px, rgba(0, 0, 0, 0.25) 25px 25px 33px`
            };
        case BorderStyle.DarkBorder:
            return { border: `${borderThickness}px solid #000` };
        case BorderStyle.LightBorder:
            return { border: `${borderThickness}px solid rgba(255, 255, 255, 0.5)` };
        case BorderStyle.BorderWith3DLeft:
            return { 
                border: `${borderThickness}px solid #000`,
                boxShadow: `-${offset}px ${offset}px 0 black`
            };
        case BorderStyle.BorderWith3DRight:
            return { 
                border: `${borderThickness}px solid #000`,
                boxShadow: `${offset}px ${offset}px 0 black`
            };
    }
};

export const BorderWrapper: React.FC<BorderWrapperProps> = ({ 
    borderStyle, 
    borderThickness, 
    borderRadius, 
    children 
}) => {
    const baseStyles = getBorderStyle(borderStyle, borderThickness);
    
    if (borderStyle === BorderStyle.BorderWith3DLeft || borderStyle === BorderStyle.BorderWith3DRight) {
        const offset = borderThickness * 3;
        return (
            <div style={{
                position: 'relative',
                width: 'fit-content',
                height: 'fit-content',
                display: 'inline-block',
             
            }}>
                <div style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    borderRadius,
                    border: `${borderThickness}px solid black`,
                    boxShadow: borderStyle === BorderStyle.BorderWith3DLeft
                        ? `-${offset}px ${offset}px 0 black`
                        : `${offset}px ${offset}px 0 black`,
                    overflow: 'hidden'
                }}>
                    {children}
                </div>
            </div>
        );
    }
    
    return (
        <div style={{
            ...baseStyles,
            borderRadius: borderRadius,
            overflow: 'hidden',
            width: 'fit-content',
            height: 'fit-content',
        }}>
            {children}
        </div>
    );
}; 